import { Input, InputProps } from '@nextui-org/react';
import React, { forwardRef } from 'react';

export type BasicInputProps = InputProps & { className?: string };

const BasicInput = forwardRef<HTMLInputElement, BasicInputProps>((props, ref) => {
  return <Input {...props} className={`${props.className}`} radius={props.radius ? props.radius : 'sm'} ref={ref} />;
});

BasicInput.displayName = 'BasicInput';

export default BasicInput;
